import { useTabSwitcher } from './context/TabSwitcherContext';
import { REVIEW_TAB_ID } from './TabLink';

export const useTabLink = (tabId: number, isDefaultTab?: boolean) => {
  const { activeTabId, setActiveTab, toggleIsReviewTabVisibleOnMobile } =
    useTabSwitcher();
  const setActiveTabHandler = () => {
    setActiveTab(tabId);

    if (tabId === REVIEW_TAB_ID) {
      toggleIsReviewTabVisibleOnMobile();
    }
  };

  const isActive: boolean =
    (typeof activeTabId === 'undefined' && isDefaultTab) ||
    activeTabId === tabId;

  return { isActive, setActiveTabHandler };
};
